/* eslint-disable no-unused-expressions */
import React, { Fragment, useEffect, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import Mcqs from './GradeMode/Mcqs';
import FillInBlanks from './GradeMode/FillInBlanks';

const AnswerQuestion = ({ answer, index, setGrade, setProfessorFeedBack, currentAnswer }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [changing, setChanging] = useState(false);

  return (
    <div className='answer_question_box' key={index} id={answer._id}>
      <div className='d-flex justify-content-between'>
        <h5 className='answer_question_type'>{answer?.question?.type}</h5>
        {(answer?.question?.type === 'mcqs' ||
          answer?.question?.type === 'blanks' ||
          answer?.question?.type === 'truefalse') &&
          isExpanded && (
            <h4
              className='v_more cursor'
              style={{ color: '#6700B2' }}
              onClick={() => {
                setChanging(true);
              }}
            >
              {changing ? 'changing score' : 'change score'}
            </h4>
          )}
      </div>
      <h4 className='answer_question_title'>{answer?.question?.text}</h4>
      <div className='d-flex justify-content-between pts_wrapper '>
        <div className='pts mb-0 d-flex align-items-center gap-1'>
          <b style={{ width: '35px', textAlign: 'center' }}>
            {answer?.totalMarks &&
              answer?.givenMarks &&
              Number((answer?.givenMarks / answer?.totalMarks) * 100).toFixed()}
            %{' '}
          </b>{' '}
          {answer.question?.type === 'mcqs' && <span style={{ fontWeight: '400' }}>|</span>}
          {(answer.question?.type === 'mcqs' || answer.question?.type === 'truefalse') && (
            <>
              <b>
                {answer.question?.type === 'mcqs' || answer.questions?.type === 'turefalse'
                  ? answer?.question?.options?.length + ' answers'
                  : answer?.question?.type === 'blanks'
                  ? answer?.question?.blanksBank?.length + ' blanks'
                  : ''}
              </b>
              <span
                style={{
                  width: '30px',
                  height: '10px',
                  background:
                    answer.question?.difficulty === 1
                      ? '#0A5C59'
                      : answer.question?.difficulty === 2
                      ? '#FFBF00'
                      : answer.question?.difficulty === 3
                      ? '#AE2604'
                      : '#AE2604',
                  borderRadius: '10px',
                  display: 'inline-block',
                }}
              ></span>
            </>
          )}
          {(answer.question?.type === 'sa' || answer.question?.type === 'fr') && (
            <span
              style={{
                width: '30px',
                height: '10px',
                background:
                  answer.question?.difficulty === 1
                    ? '#0A5C59'
                    : answer.question?.difficulty === 2
                    ? '#FFBF00'
                    : answer.question?.difficulty === 3
                    ? '#AE2604'
                    : '#AE2604',
                // fallback if marks not present
                borderRadius: '10px',
                display: 'inline-block',
              }}
            ></span>
          )}
        </div>

        <h4
          className='v_more cursor'
          onClick={() => {
            setIsExpanded((old) => !old);
            setChanging(false);
          }}
          // style={{ color: 'var(--Amber-800, #AD6302)' }}
        >
          <u>{isExpanded ? 'hide answers' : 'show answers'}</u>
        </h4>
      </div>
      {isExpanded && (
        <Fragment>
          {answer?.question?.type === 'fr' || answer?.question?.type === 'sa' ? (
            <div className='answer_box mt-2'>
              <p
                dangerouslySetInnerHTML={{
                  __html: answer?.answerText,
                }}
              ></p>
              <p className='text-end w-100 mb-0 f-12 text-black'>
                {answer?.answerText?.split(' ').length} words
              </p>
            </div>
          ) : answer?.question?.type === 'mcqs' || answer?.question?.type === 'truefalse' ? (
            <Mcqs answer={answer} isSubmitted={currentAnswer?.isSubmitted} />
          ) : answer?.question?.type === 'blanks' ? (
            <FillInBlanks answer={answer} isSubmitted={currentAnswer?.isSubmitted} />
          ) : (
            <>abc</>
          )}
          {!currentAnswer?.isSubmitted && (
            <div className='d-flex justify-content-end w-100 gradding_top'>
              <h3 style={{ color: 'rgb(174, 38, 4)' }}>Not submitted</h3>
            </div>
          )}
          {/* {  <h3 className="v_more">Instructor feedback</h3>} */}
          <Grades answer={answer} setGrade={setGrade} changing={changing} />
        </Fragment>
      )}
    </div>
  );
};
export default AnswerQuestion;

const Grades = ({ answer, setGrade, changing }) => {
  const grades = [0, 70, 80, 90, 100];
  const autoGrades = [0, 100];
  const isFreeResponse = answer?.question?.type === 'fr' || answer?.question?.type === 'sa';
  const applicableGrades = isFreeResponse ? grades : autoGrades;
  const givenPercentage = ((answer?.givenMarks / answer?.totalMarks) * 100).toFixed();

  // const uniqueGrades = applicableGrades.includes(givenPercentage) ? applicableGrades : [...applicableGrades, Number(givenPercentage)];

  return (
    <div className='editor_wrapper row'>
      {/* <ReactQuill
        theme="snow"
        value={answer?.profFeedback}
        onChange={setProfessorFeedBack}
        modules={modules}
        formats={formats}
      /> */}
      <div className='col-md-6'></div>
      {(isFreeResponse || changing) && (
        <div className='answer_grades_wrapper col-md-6 d-flex align-items-end justify-content-end gap-4'>
          <div className='d-flex gap-3 col-md-10 align-items-center justify-content-end'>
            {applicableGrades
              .sort((a, b) => a - b)
              .map((grade, index) => (
                <h6 key={index} className={`cursor  mb-0`} onClick={() => setGrade(grade)}>
                  {`${grade}%`}
                </h6>
              ))}
          </div>
          {answer.hasOwnProperty('grade') ? (
            <>
              {isFreeResponse ? (
                <h6 className='d-flex justify-content-center align-items-center active_grade col-md-2 mb-0'>
                  <input
                    type='number'
                    className='border-0 w-100 rounded'
                    value={Math.round(Number(answer?.grade))}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val < 0 || val > 100) return;
                      setGrade(val);
                    }}
                  />
                  %
                </h6>
              ) : (
                <h6 className='active_grade col-md-2 p-1 mb-0'>
                  {Math.round(Number(answer?.grade))}%
                </h6>
              )}
            </>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};
